module.exports = __webpack_public_path__ + "static/media/Aitcheson College c. 1910s.c5bd4c37.jpeg";